(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxSearchQueryConditionObjectReference', {
		bindings: {
			condition: '<',
			operators: '<',
		},
		controller: MxSearchQueryConditionObjectReferenceCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-search-query-condition/by-type/mx-search-query-condition-object-reference.html',
	});

	MxSearchQueryConditionObjectReferenceCtrl.$inject = ['$scope', 'mx.internationalization'];

	function MxSearchQueryConditionObjectReferenceCtrl($scope, i18n) {
		var vm = this;
		var orignShowCurrentUser, _pickupValues;
		var watchers = [];
		vm.$onInit = function () {
			vm.textMode = isTextMode();
			vm.stateMode = isStateMode();
			vm.condition.value = vm.condition.value || [];
			vm.reference = vm.condition.__property.ReferenceTo;

			var treeTypes = ['spssccategoryclassbase', 'spsarticlecategoryclassbase', 'plslcomponentcategoryclassbase'];
			vm.parent = vm.reference && treeTypes.indexOf(vm.reference.toLowerCase()) !== -1 ? 'Parent' : '';

			orignShowCurrentUser = vm.reference && vm.reference.toLowerCase() === 'spsuserclassbase';
			vm.showCurrentUser = orignShowCurrentUser && !vm.textMode && !vm.stateMode;
			vm.currentUser = false;
			vm._notSet = false;

			Object.defineProperty(vm, 'values', {
				get: function () {
					return _pickupValues;
				},
				set: function (val) {
					_pickupValues = val;
					setConditionValues();
				},
			});

			Object.defineProperty(vm, 'notSet', {
				get: function () {
					return vm._notSet;
				},
				set: function (val) {
					vm._notSet = val;
					setConditionValues();
				},
			});

			if (vm.condition.value.length > 0 && !vm.textMode) {
				setPickupValues();
			}

			if (!_pickupValues) {
				_pickupValues = vm.condition.value;
			}
		};

		watchers.push($scope.$watch('vm.selectedItems[0].DisplayString', setConditionDisplayValue));

		watchers.push($scope.$watch('vm.currentUser', setConditionValues));

		watchers.push(
			$scope.$watch('vm.condition.operator', function (newVal, oldVal) {
				var operatorChanged = newVal !== oldVal;
				vm.textMode = isTextMode();
				vm.stateMode = isStateMode();
				vm.condition.value = operatorChanged ? [] : vm.condition.value;
				setPickupValues();

				if ((vm.textMode && operatorChanged) || vm.stateMode) {
					vm.showCurrentUser = false;

					vm.values = null;
					vm.selectedItems = (vm.selectedItems || []).length = 0;
					vm.notSet = newVal === vm.operators.IsNotSet.value;

					if (vm.stateMode) {
						vm.condition.value.push('null');
					} else if (vm.textMode) {
						vm.condition.value = [''];
					}
					setConditionDisplayValue();
				} else {
					vm.showCurrentUser = orignShowCurrentUser;
					setConditionValues();
				}
			})
		);

		watchers.push($scope.$watch('vm.condition.value[0]', updateConditionValidity));
		$scope.$on('$destroy', function () {
			watchers.forEach(function (w) {
				w();
			});
			watchers = [];
		});

		return vm;

		function isTextMode() {
			return (
				vm.condition.operator === vm.operators.Contains.value ||
				vm.condition.operator === vm.operators.NotContains.value ||
				vm.condition.operator === vm.operators.StartsWith.value ||
				vm.condition.operator === vm.operators.EndsWith.value
			);
		}

		function isStateMode() {
			return vm.condition.operator === vm.operators.IsNotSet.value || vm.condition.operator === vm.operators.IsSet.value;
		}

		function setPickupValues() {
			var tmpArr = [];

			vm.condition.value.forEach(function (val) {
				if (val === '@me' || val === 'CURRENTUSERID()') {
					vm.currentUser = true;
				} else if (val === 'null') {
					vm._notSet = true;
				} else {
					tmpArr.push(val);
				}
			});

			_pickupValues = tmpArr;
		}

		function setConditionValues() {
			if (!vm.textMode && !vm.stateMode) {
				vm.condition.value = _pickupValues ? _pickupValues.slice() : [];
				if (vm.currentUser) {
					vm.condition.value.push('@me');
				}
				if (vm.notSet) {
					vm.condition.value.push('null');
				}

				setConditionDisplayValue();
			}
		}

		function setConditionDisplayValue() {
			if (vm.selectedItems && vm.selectedItems.length > 0) {
				vm.condition.valueString =
					'"' +
					vm.selectedItems
						.map(function (item) {
							return item.DisplayString;
						})
						.join('", "') +
					'"';
			} else {
				vm.condition.valueString = vm.stateMode ? ' ' : '';
			}

			[
				{
					val: vm.currentUser,
					lbl: 'solutionBuilderAgent.components.mx-search-query-condition-object-reference.me',
				},
				{
					val: vm.notSet && !vm.textMode && !vm.stateMode,
					lbl: 'solutionBuilderAgent.components.mx-search-query-condition-object-reference.notSet',
				},
			].forEach(function (itm) {
				if (itm.val) {
					if (vm.condition.valueString) {
						vm.condition.valueString += ' ' + i18n.get('solutionBuilderAgent.common.or_label') + ' ';
					}
					vm.condition.valueString += ' ' + i18n.get(itm.lbl) + ' ';
				}
			});
		}

		function updateConditionValidity() {
			const values = vm.condition.value;
			const withoutParamsMode = vm.condition.operator === vm.operators.IsNotSet.value || vm.condition.operator === vm.operators.IsSet.value;
			vm.condition.__valid = values.length > 0 || withoutParamsMode;
		}
	}
})();
